<template>
  <div class="card">
    <div v-if="tumorBoardAttendanceData.length > 0">
      <div class="table-header-div">
        <div class="user-icon-div">
          <UserIcon />
        </div>
        <div class="attendance-heading-div">
          <h3 class="attendance-heading">Attendees</h3>
        </div>
        <div v-if="isUserTBPersonnel" class="save-button-div">
          <Button @click="handleSaveAttendanceData()" label="Save" size="small" class="save-button" />
        </div>
        <div class="number-of-records-div"><span class="number-of-records-span">{{
          tumorBoardAttendanceData.length
        }}</span></div>
      </div>
      <DataTable :value="tumorBoardAttendanceData" paginator :rows=7 tableStyle="min-width: 10rem">
        <Column field="serialNumber" header="" sortable style="width: 3%" header-class="header-style-class"
          body-class="body-style-class"></Column>
        <Column field="name" header="PHYSICIAN NAME" sortable editable style="width: 25%"
          header-class="header-style-class" body-class="body-style-class"></Column>
        <Column field="department_name" header="SPECIALITY" sortable style="width: 25%" header-class="header-style-class"
          body-class="body-style-class"></Column>
        <Column v-if="isUserTBPersonnel" header="ATTENDANCE" style="width: 10%" header-class="header-style-class"
          body-class="body-style-class">
          <template #body="rowData">
            <div v-if="rowData">
              <label class="checkbox-label">{{ rowData.data.is_present ? "Present" : "Absent" }}</label>
              <Checkbox v-model="rowData.data.is_present" :binary="true" />
            </div>
          </template>
        </Column>
      </DataTable>
      <Toast position="bottom-right" group="br" />
    </div>
  </div>
</template>
  
<script setup >
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { computed, watch, ref } from 'vue'
import { getAttendanceListData } from './getAttendanceListData.js'
import { useStore } from 'vuex'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'
import UserIcon from '../../icons/UserIcon.vue'
import { patchAttendanceData } from './patchAttendanceData'

const store = useStore()
const meeting = computed(() => store.state.session.meeting)
const tumorBoardAttendanceData = ref([])
const userRoles = computed(() => store.getters.userRoles)
const isUserTBPersonnel = ref(false)
const toast = useToast()

watch(meeting, async (newMeeting) => {
  if (!meeting.value || !newMeeting) { return }
  const tbId = meeting.value.data.tb_id
  const date = meeting.value.data.date
  const tumorBoardAttendanceDataFromResponse = await getAttendanceListData(tbId, date)
  isUserTBPersonnel.value = userRoles.value.includes('tb-personnel')

  const sortedData = tumorBoardAttendanceDataFromResponse.sort((a, b) => {
    return a.department_name.localeCompare(b.department_name)
  })

  const sortedDataWithSerialNumbers = sortedData.map((item, index) => {
    return { ...item, serialNumber: index + 1 }
  })

  tumorBoardAttendanceData.value = sortedDataWithSerialNumbers

  store.dispatch('setTumorBoardAttendanceData', {
    tumorBoardAttendanceData: tumorBoardAttendanceData.value,
    publish: true,
  })
})

const handleSaveAttendanceData = async () => {
  const attendeesCaregiverIds = tumorBoardAttendanceData.value?.filter((attendee) => attendee.is_present)
    .map((attendee) => attendee.care_giver_id)

  const attendanceSavedData = {
    tb_id: meeting.value.data.tb_id,
    date: meeting.value.data.date,
    attendees: attendeesCaregiverIds,
  }
  await patchAttendanceData(attendanceSavedData)
  toast.add({ detail: 'Changes saved', group: 'br', life: 3000 })
}
</script>

<style >
.p-sortable-column .p-sortable-column-icon {
  /* Change the color of the sort icon here */
  color: #8F8F8F !important; /* TODO: eliminate !important */
}

.header-style-class {
  color: #8F8F8F !important; /* TODO: eliminate !important */
  font-size: 10px;
  font-weight: 500;
}

.body-style-class {
  color: #001124;
  font-size: 14px;
  font-weight: 400
}

.number-of-records-span {
  color: #001124;
  background-color: lightgray;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.number-of-records-div {
  width: 20%;
  margin-top: 4%;
}

.attendance-heading {
  margin-left: 16px;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8%;
}

.attendance-heading-div {
  width: 65%;
  text-align: initial;
}

.user-icon-div {
  width: 15%;
  margin-top: 4.5%;
  margin-left: -4%;
}

.table-header-div {
  display: flex;
  background-color: #ffffff;
}

.save-button-div {
  margin-top: 3.2%;
}

.save-button {
  background: var(--Grey800);
  border: 1px solid var(--Grey800);
}

.checkbox-label {
  margin-right: 7%;
}

.p-toast-message-content {
  background-color: var(--Grey800);
}

.p-toast-detail {
  color: var(--White);
}
</style>
